const supportedLanguage = [
    'en',
    'en-gb',
];

const initialsSupported = (language) => supportedLanguage.includes(language);

export default initialsSupported;
